import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";

export function invoiceDateToExchangeRateDate(invoiceDate: string | undefined) {
  return invoiceDate ? dayjs(invoiceDate, ISO_DATE_FORMAT).subtract(1, "day").format(ISO_DATE_FORMAT) : null;
}
